import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import {
  changeUserToken,
  getLinkedAccountList,
  switchBackToMasterAccount,
} from "../../services/clientMasterAccountService";
import handleApiError from "../../helpers/handleApiError";
import { DiliTextCP } from "../Utility/DiliTextCP";
import { BsPersonCircle } from "react-icons/bs";
import {
  handleLoginToken,
  isMainClientAccount,
  shouldFetchAccountList,
} from "../../services/accountService";
import { localStorageVariables } from "../../constants";
import { tokenKeyName } from "../../config";
import jwtDecode from "jwt-decode";
import { useHistory } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

const UserAccountsDropdownToggle = React.forwardRef(({ onClick }, ref) => {
  return (
    <button
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      style={{
        height: "100%",
        backgroundColor: "transparent",
        border: "none",
        color: "black",
        outline: "none",
        textAlign: "left",
      }}
    >
      <BsPersonCircle color="white" style={{ height: "90%", width: "auto" }} />
    </button>
  );
});

const SwitchUserMenu = ({
  setLoading,
  decodedClientInfo,
  linkedAccounts,
  setLinkedAccounts,
}) => {
  const history = useHistory();
  const [linkedAccountSearchTerm, setLinkedAccountSearchTerm] = useState("");
  const queryClient = useQueryClient();

  useEffect(() => {
    const fetchLinkedAccounts = async () => {
      //   console.log("testing switch user");
      // console.log(decodedClientInfo);
      try {
        if (shouldFetchAccountList(decodedClientInfo)) {
          // console.log(isMainAccount(decodedClientInfo));
          // console.log(isSubAccount(decodedClientInfo));
          const linkedAccountsResponse = await getLinkedAccountList();
          setLinkedAccounts(linkedAccountsResponse.data);
        }
      } catch (ex) {
        handleApiError(ex);
      }
    };

    fetchLinkedAccounts();
  }, [decodedClientInfo]);

  const handleChangeLinkedAccountSearchTerm = (e) => {
    setLinkedAccountSearchTerm(e.target.value);
  };

  const handleClickAccount = async (e, clientId, masterName, username) => {
    // console.log(username);
    // console.log(masterName);
    try {
      let newToken;
      const decodedToken = jwtDecode(localStorage.getItem(tokenKeyName));
      //if they click on an account that they are already logged in as, ignore
      if (username === decodedToken.nameid) {
        // console.log("clicked on same, ignore");
        return;
      }

      setLoading(true);
      //if we are currently logged in under a linked account, we need to switch back to the main account before we can switch again. (Idk why back end is set up this way)
      //But this will cause issues if they link an account that is for the same clientid as theirs
      if (!isMainClientAccount(decodedToken)) {
        // console.log("was logged in as another account, so need to switch back");
        const mainAccountTokenResponse = await switchBackToMasterAccount();
        newToken = mainAccountTokenResponse.data;
        handleLoginToken(newToken);
      }
      // ignore this part if they wanted to switch back to their main account.
      if (username !== decodedToken.MainAccountUsername) {
        // console.log(
        //   "clicked on a clientid that is different from the one we are logged in as, so change user"
        // );
        const linkedAccountTokenResponse = await changeUserToken(
          clientId,
          masterName
        );
        // console.log("set new token");
        newToken = linkedAccountTokenResponse.data;
        handleLoginToken(newToken, true);
      }
      //   console.log(newTokenResponse);
      queryClient.invalidateQueries();
      window.location.reload();
      //don't call setLoading(false) so it keeps loading until window refreshes.
    } catch (ex) {
      handleApiError(ex, history);
      setLoading(false);
    }
  };

  const handleClickMainAccount = async (username) => {
    try {
      let newToken;
      const decodedToken = jwtDecode(localStorage.getItem(tokenKeyName));
      // console.log(decodedToken);
      //if they click on an account that they are already logged in as, ignore
      if (!isMainClientAccount(decodedToken)) {
        setLoading(true);
        // console.log(
        //   "clicked main account and was logged in as another account, so switching back"
        // );
        const mainAccountTokenResponse = await switchBackToMasterAccount();
        newToken = mainAccountTokenResponse.data;
        handleLoginToken(newToken);
        queryClient.invalidateQueries();
        window.location.reload();
      }
    } catch (ex) {
      setLoading(false);
      handleApiError(ex, history);
    }
  };

  return (
    <Dropdown.Menu className="navbar-profile-accounts-dropdown-align pb-0">
      <div className="py-2 px-3">
        <DiliTextCP
          label="Linked Accounts"
          value={linkedAccountSearchTerm}
          onChange={handleChangeLinkedAccountSearchTerm}
          placeholder="Search Linked Accounts..."
        />
      </div>
      <div
        className="custom-scrollbar custom-scrollbar-inherit-border-right"
        style={{
          backgroundColor: "rgb(250,251,252)",
          height: "300px",
          maxHeight: "500px",
          minWidth: "300px",
          overflowY: "auto",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "sticky",
            top: 0,
            left: 0,
            right: 0,
            height: "1px",
            backgroundColor: "inherit",
            boxShadow: "0px 0px 5px 0px black",
          }}
        ></div>
        <Dropdown.Item
          className={
            "list-border-bottom pl-2" +
            (isMainClientAccount(decodedClientInfo)
              ? " navbar-profile-accounts-selected-account"
              : "")
          }
          onClick={handleClickMainAccount}
        >
          <div className="pl-4 p-1">
            Main Account
            <div className="font-small text-faint">
              {localStorage.getItem(localStorageVariables.clientId)} -{" "}
              {localStorage.getItem(localStorageVariables.userid)}
            </div>
          </div>
        </Dropdown.Item>
        {linkedAccounts
          ?.filter((linkedAccount) => {
            return (
              linkedAccount.masterName
                .toLowerCase()
                .includes(linkedAccountSearchTerm.toLowerCase()) ||
              ("" + linkedAccount.clientId)
                .toLowerCase()
                .includes(linkedAccountSearchTerm) ||
              linkedAccount.username
                .toLowerCase()
                .includes(linkedAccountSearchTerm.toLowerCase())
            );
          })
          .map((linkedAccount, index) => {
            return (
              <Dropdown.Item
                key={linkedAccount.username + "-" + index}
                className={
                  "list-border-bottom pl-2" +
                  (linkedAccount.username === decodedClientInfo.nameid
                    ? " navbar-profile-accounts-selected-account"
                    : "")
                }
                onClick={(e) => {
                  handleClickAccount(
                    e,
                    linkedAccount.clientId,
                    linkedAccount.masterName,
                    linkedAccount.username
                  );
                }}
              >
                <div className="pl-4 p-1">
                  <div>{linkedAccount.masterName}</div>
                  <div className="font-small text-faint">
                    {linkedAccount.clientId} - {linkedAccount.username}
                  </div>
                </div>
              </Dropdown.Item>
            );
          })}
      </div>
    </Dropdown.Menu>
  );
};

export const SwitchUser = ({
  setLoading,
  decodedClientInfo,
  linkedAccounts,
  setLinkedAccounts,
}) => {
  return (
    <Dropdown title="Switch User" drop="down" className="pr-3">
      {/* <Dropdown.Toggle
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: "transparent",
          border: "none",
          color: "black",
          textAlign: "left",
        }}
      >
        <BsPersonCircle
          color="white"
          style={{ height: "100%", width: "100%" }}
        />
      </Dropdown.Toggle> */}
      <Dropdown.Toggle as={UserAccountsDropdownToggle}></Dropdown.Toggle>
      <SwitchUserMenu
        setLoading={setLoading}
        decodedClientInfo={decodedClientInfo}
        linkedAccounts={linkedAccounts}
        setLinkedAccounts={setLinkedAccounts}
      />
    </Dropdown>
  );
};
